import { create } from 'zustand';

type TourRestartRequest = { tourId: string; token: number } | null;

type TourState = {
  restartRequest: TourRestartRequest;
  requestRestart: (tourId: string) => void;
};

export const useTourStore = create<TourState>((set) => ({
  restartRequest: null,
  requestRestart: (tourId) => set({ restartRequest: { tourId, token: Date.now() } }),
}));
